/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type CategoryTiles_viewer$ref = any;
export type SbRespNullSearchResultsTilesLoaderQueryVariables = {
    readonly showModules: boolean;
};
export type SbRespNullSearchResultsTilesLoaderQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": CategoryTiles_viewer$ref;
    } | null;
};
export type SbRespNullSearchResultsTilesLoaderQuery = {
    readonly response: SbRespNullSearchResultsTilesLoaderQueryResponse;
    readonly variables: SbRespNullSearchResultsTilesLoaderQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "showModules",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "categoryLevels",
        "value": 2
    } as any), v2 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v3 = ({
        "kind": "Literal",
        "name": "trendType",
        "value": "CATEGORY"
    } as any), v4 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "image",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SbRespNullSearchResultsTilesLoaderQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CategoryTiles_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SbRespNullSearchResultsTilesLoaderQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "showModules",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "trendingFurniture",
                                    "name": "trending",
                                    "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FURNITURE\",trendType:\"CATEGORY\")",
                                    "args": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "parentCategory",
                                            "value": "FURNITURE"
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "TrendingModules",
                                    "plural": true,
                                    "selections": (v4 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "trendingArt",
                                    "name": "trending",
                                    "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"ART\",trendType:\"CATEGORY\")",
                                    "args": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "parentCategory",
                                            "value": "ART"
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "TrendingModules",
                                    "plural": true,
                                    "selections": (v4 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "trendingFashion",
                                    "name": "trending",
                                    "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FASHION\",trendType:\"CATEGORY\")",
                                    "args": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "parentCategory",
                                            "value": "FASHION"
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "TrendingModules",
                                    "plural": true,
                                    "selections": (v4 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "trendingJewelry",
                                    "name": "trending",
                                    "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"JEWELRY\",trendType:\"CATEGORY\")",
                                    "args": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "parentCategory",
                                            "value": "JEWELRY"
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "TrendingModules",
                                    "plural": true,
                                    "selections": (v4 /*: any*/)
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SbRespNullSearchResultsTilesLoaderQuery",
            "id": "app-buyer-finding/233.0.0-2019-09-19T10:07:06.974Z/SbRespNullSearchResultsTilesLoaderQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '401813d1921dab01e128b3597f448a73';
export default node;
